var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTower = function SvgTower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 34960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 34959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4874",
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "url(#paint0_linear_4916_512)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2982 41.9712C15.6393 41.9356 14.3357 41.855 13.2255 41.6729L15.077 23.1735C15.077 22.5548 14.6804 22.1528 14.1938 22.2005H11.0894V13.8181H14.0139V15.6331C14.0139 16.1251 14.4159 16.5217 14.9024 16.5217H19.2919C19.7838 16.5217 20.1804 16.1197 20.1804 15.6331V13.8181H23.6814V15.6329C23.6814 16.1248 24.0834 16.5214 24.5699 16.5214H28.9594C29.4514 16.5214 29.848 16.1194 29.848 15.6329V13.8179H32.8201V22.1949H29.7158C29.1816 22.1949 28.8272 22.5916 28.8272 23.168C29.3103 27.5889 29.6829 31.4309 30.1271 36.0098C30.2978 37.7688 30.4789 39.6365 30.681 41.6875C29.5698 41.8627 28.264 41.9395 26.606 41.9732V35.9876C26.606 33.4174 24.5223 31.3337 21.9521 31.3337C19.3819 31.3337 17.2982 33.4174 17.2982 35.9876V41.9712Z",
    fill: "#FFC10D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4639 41.9968C23.7074 42 22.8891 42 22.0001 42C20.6313 42 19.4302 42 18.3638 41.9884V35.8102C18.3638 34.2027 19.7237 32.9092 21.4138 32.9092C23.104 32.9092 24.4639 34.2027 24.4639 35.8102V41.9968Z",
    fill: "#56ACE0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_512",
    x1: 22,
    y1: 2,
    x2: 22,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473FF"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tower.d6b9f0bc.svg";
export { ForwardRef as ReactComponent };